<template>
    <div class="row" v-if="apiStore.isAdmin">
        <div class="col-sm"><RoomFilter :eventId="eventId" @filterChanged="filterChangedHandler" v-if="false && 0 < eventId" />&nbsp;</div>
        <div class="col-sm x"><EventEditLink :event="event" cssClass="event-edit" /></div>
    </div>

    <SkeletonPage v-if="loading" bones="event-header, event-navigation, expand-collapse, session-date, session-item, session-item" />

    <h1 v-show="false == loading" ref="mainHeading">Schedule</h1>
    <EventNavigation :eventId="parseInt($route.params.eventId)" v-if="false == loading" :visibilities="apiStore.navigationVisibilities" />
    <RegistrationButton v-if="false == apiStore.isRegisteredForCurrentEvent && false == loading" :event="event" />
    <div v-if="apiStore.isRegisteredForCurrentEvent" class="sign pattan-success">You are registered for this event</div>
    <div v-if="errorMessage && '' !== errorMessage"><span class="dev-output">{{ errorMessage }}</span></div>
    <p v-if="false == loading && 0 == sessions.length" class="announcement">There are no published sessions for this event</p>
    <ExpandCollapseSessionDescription v-if="!loading && sessions.length"></ExpandCollapseSessionDescription>
    <div :key="renderKey">
        <SessionList :sessions="sessions" :showSessionButtons="event.personal_schedules" v-if="false == loading && sessions.length > 0"
            @session-added="sessionAddedHandler" @session-removed="sessionRemovedHandler" viewParent="schedule"
            :showRoomsCollapsed="true" :showMaterials="showMaterials" :hasTimeslots="event.has_timeslots" :dateString="event.dateString" />
    </div>
</template>

<script>
import {checkForAppReload, setRegistrationStatus} from '@/shared/StateHelper'
import {checkForSignIn, reloadAttendee, setSignOutLink} from '@/shared/susiHelper'
import dayjs from 'dayjs'
import EventEditLink from '@/components/EventEditLink'
import EventNavigation from '@/components/EventNavigation'
import ExpandCollapseSessionDescription from '@/components/ExpandCollapseSessionDescription'
import {getCurrentEventShortName} from '@/App'
import {getEventById, storeSessionsByEventId} from '@/shared/ApiHelper'
import RegistrationButton from '@/components/RegistrationButton'
import RoomFilter from '@/components/RoomFilter'
import SessionList from '@/components/SessionList'
import SkeletonPage from '@/components/SkeletonPage'
import {useApiStore} from "@/store/api.js"

export default {
    name: 'ScheduleView',

    components: {
        EventEditLink,
        EventNavigation,
        ExpandCollapseSessionDescription,
        RegistrationButton,
        RoomFilter,
        SessionList,
        SkeletonPage,
    },

    computed: {
        eventId() {
            return this.event.id
        },
    },

    async created() {
        try {
            checkForSignIn(this.apiStore.baseUrl)
            if (this.apiStore.oid && null == this.apiStore.currentAttendee) {
                await reloadAttendee()
            }
            this.event = await getEventById(this.$route.params.eventId)
            if (await checkForAppReload(this.$route, this.event, this.apiStore)) {
                if (this.apiStore.oid) {
                    await setSignOutLink()
                }
            }

            document.title = this.documentTitle + ': ' + getCurrentEventShortName()

            if (undefined === this.apiStore.currentEvent.sessions || null == this.apiStore.currentEvent.sessions) {
                this.areSessionsCached = false
                await storeSessionsByEventId(this.event.id)
            } else {
                this.areSessionsCached = true
            }
            this.sessions = this.apiStore.currentEvent.sessions
            if (0 < this.sessions.length) {
                const today = dayjs()
                const visible_date = this.event.visible_date ? dayjs(this.event.visible_date) : today
                const visibility = today >= visible_date
                for(let i = 0; i < this.sessions.length; ++i){
                    this.sessions[i].visible = true
                    this.sessions[i]['showRoom'] = this.sessions[i]['showMaterial'] = visibility
                }
            }

            if (this.apiStore.oid && this.apiStore.currentEvent) {
                await setRegistrationStatus(this.apiStore)
            }

            this.showMaterials = null == this.event.visible_date || dayjs().format('YYYY-MM-DD') >= this.event.visible_date 

        } catch (exception) {
             this.errorMessage = exception.stack
        } finally {
            this.loading = false
        }
    },

    data() {
        return {
            apiStore: useApiStore(),
            areSessionsCached: true,
            documentTitle: 'Event Schedule',
            errorMessage: null,
            event: {},
            sessions: [],
            loading: true,
            oid: null,
            renderKey: 0,
            showMaterials: false,
        }
    },

    methods: {
        getPublishedSessions(sessions) {
            let publishedOnly = sessions.filter(
                function(item){
                    return  item.is_published == true;
                }
            )

            return publishedOnly;
        },

        filterChangedHandler(value) {
            if (0 < value) {
                for (let i = 0; i < this.sessions.length; ++i) {
                    this.sessions[i].visible = this.sessions[i].room && this.sessions[i].room.id == value
                }
            } else {
                for (let i = 0; i < this.sessions.length; ++i) {
                    this.sessions[i].visible = true
                }
            }
        },

        sessionAddedHandler(value) {
            let i = 0
            while(this.sessions[i].id != value) {
                ++i
            }
            this.sessions[i].attending = true
            this.renderKey++
            // This change might affect the default Event view: force update
            reloadAttendee()
            this.apiStore.events = null
        },

        sessionRemovedHandler(value) {
            let i = 0
            while(this.sessions[i].id != value) {
                ++i
            }
            this.sessions[i].attending = false
            this.renderKey++
            // This change might affect the default Event view: force update
            reloadAttendee()
            this.apiStore.events = null
        },
    },

    mounted() {
        if (this.$refs.throbber) {
            this.$refs.throbber.setFocus() // screenreader politeness
        }
    },
}
</script>

<style scoped>

.event-dates {
    font-weight: 600;
}

.event-edit {
    font-size: 200%;
}

</style>